var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name === 'reports')?_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_vm._v("Выберите учебный год")])])],1)],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }